module.exports = __webpack_public_path__ + "img/live.10374b25.jpg";